import formHelpers from "../utils/formHelpers";

class Filters {
    constructor(element) {
        this.el = element;
        this.container = document.querySelector(".feed-list");
        this.default_list = this.container.innerHTML;
        this.init();
    }

    init() {
        this.form = this.el.querySelector("form");

        this.form_type = this.form.dataset.type;

        this.form.addEventListener(
            "submit",
            formHelpers[this.form_type].formSubmit,
        );

        this.filterStatus();
        this.reset();
    }

    filterStatus() {
        // Collect form data
        let form_data = new FormData(this.form);

        formHelpers.status(this.form, form_data);

        // // Display selected filters status
        // if (this.form.hasAttribute("data-display-status")) {
        //     let status_element = document.querySelector("[data-form-status]");
        //     let message = status_element.querySelector("[data-status-message]");
        //     message.innerHTML = "";

        //     let status = [];
        //     for (const pair of form_data.values()) {
        //         if (pair[1]) {
        //             let label = document.querySelector(`[value="${pair[1]}"`);
        //             status.push([
        //                 `<span class="filter-status">${pair[0]}: ${label.textContent}</span>`,
        //             ]);
        //         }
        //         console.log(status, pair);
        //     }
        //     if (status.length) {
        //         status = `Currently filtered by ${status.join(" and ")}`;
        //         message.innerHTML = status;
        //         status_element.classList.add("active");
        //     }
        // }
    }

    reset() {
        let reset = this.el.querySelector('[type="reset"]');

        if (reset) {
            const select = this.el.querySelectorAll("select");
            const checkbox = this.el.querySelectorAll('[type="checkbox"]');
            const submit = this.el.querySelector('[type="submit"]');
            let status_element = document.querySelector("[data-form-status]");

            reset.addEventListener("click", (e) => {
                e.preventDefault();

                if (this.form_type == "simple") {
                    reset.classList.remove("active");

                    console.log(this.container, this.default_list);
                    this.container.innerHTML = this.default_list;
                }
                select.forEach((item) => {
                    item.value = "";
                });

                checkbox.forEach((item) => {
                    item.checked = false;
                });

                // submit.click();
                if (this.form_type == "ajax") {
                    this.form.dispatchEvent(new Event("submit"));
                }

                window.history.replaceState(null, null, this.form.action);

                if (status_element) status_element.classList.remove("active");
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(
        ".section--filters:not(.section--filters__whats-on)",
    );

    sections.forEach((element) => {
        new Filters(element);
    });
});
